/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- MONETIZATION DIVISION : STYLES --------------- ++++++++++ */
export default theme => ({
    monetization: {
        '& .cardwrapper': {
            marginBottom: pxToEm(16)
        }
	}
});
